import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"

export const getTeams = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/teams`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    return response.data
};

export const createTeam = async (name, quarter) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.post(
            `${apiUrl}admin/teams`,
            {
                name: name,
            }, // The request body should go here
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json", // Explicitly setting the content type
                },
                params: quarter, // Query parameters
            }
        );
        toast.success(response.data.message);
    }
    catch (error) {
        error.response.data?.message? toast.error(response.data.message): toast.error(error.response.data)
    }
};

export const deleteTeam = async (id) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.delete(
            `${apiUrl}admin/teams`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                data: { id: id }, // Move request body inside `data`
            }
        );
        toast.success(response.data.message);
    }
    catch (error) {
        error.response.data?.message? toast.error(error.response.data.message): toast.error(error.response.data)
    }
};

export const modifyTeam = async (modifiedTeam) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.put(
            `${apiUrl}admin/teams`,
            modifiedTeam,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        toast.success(response.data.message);
    }
    catch (error) {
        error.response.data?.message? toast.error(response.data.message): toast.error(error.response.data)
    }
};